import { z } from "@/zod";
import { roleId } from "@/schemas/commonFields";
import { assignments } from "./assignments";

export const roleBasedAssignments = assignments.extend({
  project_role_id: roleId,
  project_role_name: z.string(),
  project_id: z.string().length(26),
  project_name: z.string(),
});

export const readRoleBasedAssignments = roleBasedAssignments.readonly();
export const readRoleBasedAssignmentsWithRef = roleBasedAssignments
  .extend({
    project_ref_number: z.string(),
  })
  .readonly();

export const writeRoleBasedAssignments = roleBasedAssignments
  .omit({
    id: true,
    store_name: true,
    contractor_name: true,
    status: true,
    project_name: true,
    project_id: true,
    project_role_name: true,
  })
  .extend({
    end_date: z.string().date().optional().catch(undefined),
  });
